import http from '@/helpers/api';

export const getAI = (data) => {
  return http.post(`/helpers/openAI`, data);
};
